
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingGrid extends Serenity.EntityGrid<DismantlingRow, any> {
        protected getColumnsKey() { return 'Production.Dismantling'; }
        protected getDialogType() { return DismantlingDialog; }
        protected getIdProperty() { return DismantlingRow.idProperty; }
        protected getInsertPermission() { return DismantlingRow.insertPermission; }
        protected getLocalTextPrefix() { return DismantlingRow.localTextPrefix; }
        protected getService() { return DismantlingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(61);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[61].AutoPosting;
            this.editItem(<DismantlingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId, 
                UserId:  userDefinition.UserId,
                VoucherTypeId: 61,
                AutoPosting: autoposting


            });
        }
    }
}